// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"c2a0748b","498":"de7bd499","513":"d5ff61a5","787":"33c9b9a9"}[chunkId] + ".chunk.js";
};